import { useEffect, useState } from "react";
import { db } from "../db";
import { fmtDateTime } from "../lib";
import { Shell, type ScreenProps } from "./common";
import { BUILD } from "../update";

export default function Profile({
  updateReady, back, nav, state, user, onSync, onLogout,
}: ScreenProps & { onLogout: () => void }) {
  const [counts, setCounts] = useState({ points: 0, visits: 0, contacts: 0 });
  const [confirmExit, setConfirmExit] = useState(false);

  useEffect(() => {
    void (async () => {
      const [points, visits, contacts] = await Promise.all([
        db.points.count(), db.visits.count(), db.contacts.count(),
      ]);
      setCounts({ points, visits, contacts });
    })();
  }, [state.lastSync, state.pending]);

  const pending = state.pending + state.photosPending;

  return (
    <Shell title="Профиль" onBack={back} state={state} updateReady={updateReady}>
      <div className="card">
        <h2>{user.name}</h2>
        <div className="hint">
          {user.role === "manager" ? "Руководитель" : "Медицинский представитель"}
        </div>
      </div>

      {user.role === "manager" && (
        <div className="block">
          <div className="blockhead"><span className="blocktitle">Управление</span></div>
          <button className="btn wide" onClick={() => nav({ name: "staff" })}>
            Сотрудники и доступы
          </button>
          <div className="hint" style={{ margin: "9px 0 14px" }}>
            Завести сотрудника, выписать ссылку, отозвать доступ
          </div>
          <button className="btn wide" onClick={() => nav({ name: "issue" })}>
            Выдача раздатки
          </button>
          <div className="hint" style={{ margin: "9px 0 14px" }}>
            Записать, что выдали сотруднику, и посмотреть остатки на руках
          </div>
          <button className="btn wide" onClick={() => nav({ name: "export" })}>
            Выгрузка визитов
          </button>
          <div className="hint" style={{ marginTop: 9 }}>
            Скачать визиты сотрудников за период в Excel
          </div>
        </div>
      )}

      <div className="block">
        <div className="blockhead"><span className="blocktitle">Синхронизация</span></div>
        <dl className="kv">
          <dt>Последняя связь</dt>
          <dd>{state.lastSync ? fmtDateTime(state.lastSync) : "ещё не было"}</dd>
        </dl>
        <dl className="kv">
          <dt>Ждут отправки</dt>
          <dd>
            {pending === 0 ? "всё отправлено"
              : `${state.pending} записей, ${state.photosPending} фото`}
          </dd>
        </dl>
        <dl className="kv"><dt>Точек в памяти</dt><dd>{counts.points}</dd></dl>
        <dl className="kv"><dt>Визитов</dt><dd>{counts.visits}</dd></dl>
        <dl className="kv"><dt>Контактов</dt><dd>{counts.contacts}</dd></dl>
        {state.error && <div className="err" style={{ marginBottom: 0 }}>{state.error}</div>}
        <div style={{ marginTop: 12 }}>
          <button className="btn tiny" onClick={onSync} disabled={state.running}>
            {state.running ? "Отправляем…" : "Отправить сейчас"}
          </button>
        </div>
      </div>

      <div className="note">
        Если интернета нет — всё сохраняется в памяти планшета и уйдёт само,
        как только появится связь. Делать для этого ничего не нужно.
      </div>

      <button className="btn wide" onClick={() => nav({ name: "help" })}>
        Как пользоваться
      </button>

      <div className="hint" style={{ textAlign: "center", marginTop: 14 }}>
        Версия приложения от {BUILD}
        {updateReady && " · обновление готово, кнопка вверху"}
      </div>

      {!confirmExit ? (
        <button className="btn wide" onClick={() => setConfirmExit(true)} style={{ marginTop: 20 }}>
          Выйти
        </button>
      ) : (
        <div className="block" style={{ marginTop: 20, borderColor: "var(--crit)" }}>
          <div className="blocktitle" style={{ marginBottom: 8 }}>Точно выйти?</div>
          <div className="hint" style={{ marginBottom: 12 }}>
            {pending > 0
              ? `Внимание: ${pending} записей ещё не отправлены. При выходе они пропадут — сначала дождись отправки.`
              : "Данные с планшета сотрутся. Чтобы войти снова, понадобится логин и пароль."}
          </div>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            <button className="btn" onClick={() => setConfirmExit(false)}>Остаться</button>
            <button className="btn primary" onClick={onLogout}>Выйти и стереть</button>
          </div>
        </div>
      )}
    </Shell>
  );
}
